import { render, staticRenderFns } from "./about.vue?vue&type=template&id=734e0de1&scoped=true"
var script = {}
import style0 from "./about.vue?vue&type=style&index=0&id=734e0de1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734e0de1",
  null
  
)

export default component.exports